import { toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-126b135a");

_pushScopeId("data-v-126b135a");

var _hoisted_1 = {
  class: "drawer-container"
};
var _hoisted_2 = {
  class: "drawer-title"
};
var _hoisted_3 = {
  class: "drawer-item"
};
var _hoisted_4 = {
  class: "drawer-item"
};
var _hoisted_5 = {
  class: "drawer-item"
};
var _hoisted_6 = {
  class: "drawer-item"
};
var _hoisted_7 = {
  key: 0,
  href: "https://panjiachen.github.io/vue-element-admin-site/zh/job/",
  target: "_blank",
  class: "job-link"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_switch = _resolveComponent("el-switch");

  var _component_el_alert = _resolveComponent("el-alert");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", null, [_createVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('settings.title')), 1
  /* TEXT */
  ), _createVNode("div", _hoisted_3, [_createVNode("span", null, _toDisplayString(_ctx.$t('settings.theme')), 1
  /* TEXT */
  ), _createCommentVNode(" <theme-picker style=\"float: right; height: 26px; margin: -3px 8px 0 0\" @change=\"themeChange\" /> ")]), _createVNode("div", _hoisted_4, [_createVNode("span", null, _toDisplayString(_ctx.$t('settings.tagsView')), 1
  /* TEXT */
  ), _createVNode(_component_el_switch, {
    modelValue: $options.tagsView,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $options.tagsView = $event;
    }),
    class: "drawer-switch"
  }, null, 8
  /* PROPS */
  , ["modelValue"])]), _createVNode("div", _hoisted_5, [_createVNode("span", null, _toDisplayString(_ctx.$t('settings.fixedHeader')), 1
  /* TEXT */
  ), _createVNode(_component_el_switch, {
    modelValue: $options.fixedHeader,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $options.fixedHeader = $event;
    }),
    class: "drawer-switch"
  }, null, 8
  /* PROPS */
  , ["modelValue"])]), _createVNode("div", _hoisted_6, [_createVNode("span", null, _toDisplayString(_ctx.$t('settings.sidebarLogo')), 1
  /* TEXT */
  ), _createVNode(_component_el_switch, {
    modelValue: $options.sidebarLogo,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $options.sidebarLogo = $event;
    }),
    class: "drawer-switch"
  }, null, 8
  /* PROPS */
  , ["modelValue"])]), $options.isShowJob ? (_openBlock(), _createBlock("a", _hoisted_7, [_createVNode(_component_el_alert, {
    title: "部门目前非常缺人！有兴趣的可以点击了解详情。坐标: 字节跳动",
    type: "success",
    closable: false
  })])) : _createCommentVNode("v-if", true)])]);
});